//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import axios from 'axios'

import { AXIOS, axiosRequest } from '../../axios/axios.js'
import RequestProposedBrigades from './RequestProposedBrigades.vue'
import RequestProposedEmployees from './RequestProposedEmployees.vue'
import DispatcherTasksTabSelectExecutor from '../../pages/main/sections/Dispatcher/DispatcherTab/DispatcherTasksTabSelectExecutor.vue'
import { prepareNewRequestInfo } from './RequestExecutorUtils'

const AXIOS_CUSTOM = axios.create({ baseURL: '/' })
AXIOS_CUSTOM.defaults.timeout = 3 // ms

export default {
  name: 'RequestExecutorSelectionWindow',
  components: {
    RequestProposedBrigades: RequestProposedBrigades,
    DispatcherTasksTabSelectExecutor: DispatcherTasksTabSelectExecutor
  },
  props: {
    request: {
      type: Object,
      required: true
    },
    reinforcement: {
      type: Boolean,
      default: false
    },
    simpleMode: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      opened: false,
      resolve: null,
      reject: null,

      // proposedExecutorObject: null, // not reactive
      executorsTypes: [
        {
          text: 'Выбрать бригаду',
          key: 'brigade'
        },
        {
          text: 'Выбрать Подрядчика',
          key: 'brigadeContractor'
        },
        {
          text: 'Выбрать офисного сотрудника',
          key: 'employee'
        },
        {
          text: 'Назначить себя',
          key: 'self'
        }
      ],

      simple: this.simpleMode === true,

      proposedBrigadesSimpleOpened: false,
      proposedBrigadesModalOpened: false,
      proposedBrigades: [],
      tempProposedBrigade: undefined,
      selectedReinforcementBrigades: [],
      selectedActiveExecuter: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    requestIdWrapped: function () {
      return this.request.requestId ? [this.request.requestId] : []
    },
    roleExternalDispatcher: function () {
      const user = this.$store.getters.getUser
      return !!(user.employee && user.employee.external && (user.hasRoleStrict('dispatcher') || user.hasRoleStrict('externalDispatcher')))
    },
    availableExecutorsTypes: function () {
      const executableOnDeparture = !!(this.request._configuration && this.request._configuration.executableOnDeparture)
      // const performRequestRoles = this.request._configuration && this.request._configuration.performeRequestRole || []
      if (!executableOnDeparture || this.roleExternalDispatcher) {
        return this.executorsTypes.filter(executorType => executorType.key === 'employee' || executorType.key === 'self')
      }
      const user = this.$store.getters.getUser
      if (!user.hasRole('admin', 'dispatcher') && user.hasSystemRoleStrict('contractorDispatcher')) {
        const brigadeAccess = user.hasSystemRole('requestAssignToBrigade')
        const selfAccess = user.hasSystemRole('contractorSelfExecution')
        return this.executorsTypes.filter(executorType => brigadeAccess && executorType.key === 'brigade' || selfAccess && executorType.key === 'self')
      }
      return this.executorsTypes
    }
  },
  watch: {
    simpleMode: function (value) {
      this.simple = value === true
    }
  },
  methods: {
    select: function () {
      this.proposedExecutorObject = null

      return new Promise((resolve, reject) => {
        // const requestId = this.request.requestId
        // const bpStateId = this.request.bpStateId
        // if (requestId != null && typeof requestId === 'number' && (bpStateId === 'BS2' || bpStateId === 'BS10' || bpStateId === 'BS13')) {
        //   this.opened = true
        // } else {
        //   this.showProposedBrigades()
        // }
        if (this.reinforcement) {
          this.showProposedBrigades()
        } else {
          this.opened = true
        }

        this.resolve = function (value) {
          resolve(value)
        }
        this.reject = function () {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject('cancel')
        }
      })
    },
    confirm: function () {
      this.opened = false
      !!this.resolve && this.resolve(this.proposedExecutorObject)
    },
    close: function () {
      this.opened = false
      this.selectedActiveExecuter = null
      !!this.reject && this.reject()
    },
    onExecutorTypeSelected: function (typeData) {
      this.selectedActiveExecuter = typeData.key
      if (typeData.key === 'brigade') {
        // Всегда простая форма при выборе бригады
        this.proposedBrigadesSimpleOpened = true
        // if (this.simple) {
        //   this.proposedBrigadesSimpleOpened = true
        // } else {
        //   this.showProposedBrigades(false)
        // }
      } else if (typeData.key === 'brigadeContractor') {
        this.showProposedBrigades(true)
      } else if (typeData.key === 'employee') {
        this.showProposedEmployees()
      } else {
        this.saveSelfSelection()
      }
    },
    showProposedBrigades: async function (contractor) {
      this.$q.loading.show({
        message: 'Загрузка страницы выбора бригад...',
        messageColor: 'blue-11',
        spinnerColor: 'blue-11'
      })
      try {
        this.proposedBrigades = await this.getProposedBrigades(contractor)
        this.tempProposedBrigade = null
        this.proposedBrigadesModalOpened = true
      } catch (e) {
        this.$q.loading.hide()
        if (e.message && e.message.startsWith('timeout ') && !contractor) {
          this.simple = true
          this.proposedBrigadesSimpleOpened = true
        } else {
          this.$q.notify({
            type: 'negative',
            message: 'Ошибка загрузки предложенных бригад',
            progress: true,
            timeout: 8000
          })
        }

        console.error('Ошибка загрузки предложенных бригад \n', e)
      } finally {
        this.$q.loading.hide()
      }
    },
    getProposedBrigades: function (contractor, list) {
      let url
      const bodyFormData = new FormData()
      if (typeof this.request.requestId === 'number') {
        url = '/service/delta/request/proposeRequestBrigades'
        bodyFormData.set('requestId', this.request.requestId)
        if (list) {
          bodyFormData.set('list', true)
        }
      } else {
        url = '/service/delta/request/proposeBrigades'
        prepareNewRequestInfo(this.request, bodyFormData)
      }
      bodyFormData.set('extended', 'true')
      if (contractor != null) {
        bodyFormData.set('contractor', contractor)
      }
      bodyFormData.set('reorderRequests', false)
      bodyFormData.set('maxRequestsCountToSort', 7)

      const axiosInstance = contractor || this.reinforcement ? AXIOS : AXIOS_CUSTOM
      return axiosRequest(axiosInstance({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      }), {
        onSuccess: (response) => {
          let proposedBrigades = response.data.result
          let assignedBrigadesId
          if (this.request.proposedExecutorObject && this.request.proposedExecutorObject.type === 'brigade') {
            assignedBrigadesId = this.request.proposedExecutorObject.executor.brigadeId
          } else if (this.request.assignedBrigade) {
            assignedBrigadesId = this.request.assignedBrigade.id
          }
          if (this.reinforcement) {
            proposedBrigades = proposedBrigades.filter(br => br.brigadeId !== assignedBrigadesId)
            proposedBrigades.forEach(br => {
              this.$set(br, 'isChecked', false)
            })
          } else {
            proposedBrigades.forEach(br => {
              if (br.brigadeId === assignedBrigadesId) {
                this.$set(br, 'alreadyAssigned', true)
              }
            })
          }

          let assignedReinforcingBrigadesIds
          let fixedReinforcingBrigadesIds
          if (this.request.proposedReinforcementExecutorObject) {
            assignedReinforcingBrigadesIds = this.request.proposedReinforcementExecutorObject.executors.map(br => br.brigadeId)
            fixedReinforcingBrigadesIds = new Set(this.request.proposedReinforcementExecutorObject.executors.filter(br => br.isCheckedFixed === true).map(br => br.brigadeId))
          } else if (this.request.riAssignedBrigades) {
            assignedReinforcingBrigadesIds = this.request.riAssignedBrigades.map(br => br.id)
            fixedReinforcingBrigadesIds = new Set(this.request.riAssignedBrigades.filter(br => (br.riStateId === 'RI3' || br.riStateId === 'RI4')).map(br => br.id))
          }
          if (assignedReinforcingBrigadesIds && assignedReinforcingBrigadesIds.length) {
            assignedReinforcingBrigadesIds = new Set(assignedReinforcingBrigadesIds)
            proposedBrigades.forEach(br => {
              const assigned = assignedReinforcingBrigadesIds.has(br.brigadeId)
              this.$set(br, 'isChecked', assigned)
              if (assigned && fixedReinforcingBrigadesIds.has(br.brigadeId)) {
                this.$set(br, 'isCheckedFixed', true)
              }
            })
          }

          function getAggregatedConditionType (type) {
            const aggregatedType = null
            if (type) {
              if (type === 'equipment' || type === 'tool' || type === 'availabletool') {
                return 'equipment'
              } else if (type === 'skill' || type === 'qualification') {
                return 'skills'
              } else if (type === 'minEmployersCount' || type === 'noEmployees') {
                return 'employees'
              } else if (type === 'brigadeEndWorkTimeExceeded') {
                return 'workTime'
              } else if (type === 'differentWorkAreas') {
                return 'workArea'
              } else if (type === 'brigadeEndWorkTimeExceeded') {
                return 'region'
              }
            }
            if (!aggregatedType) {
              return 'other'
            }
          }

          proposedBrigades.forEach((brigade) => {
            const conditionsResultsInfo = {}
            const unsuccessConditionsResults = brigade.unsuccessConditionsResults
            if (unsuccessConditionsResults) {
              for (let i = 0; i < unsuccessConditionsResults.length; i++) {
                const result = unsuccessConditionsResults[i]
                const aggregatedType = getAggregatedConditionType(result.type)
                const maxScoreFactor = conditionsResultsInfo[aggregatedType]
                if (maxScoreFactor === undefined || maxScoreFactor < result.scoreFactor) {
                  conditionsResultsInfo[aggregatedType] = result.notAchievedAction === 'stop' ? 5 : result.scoreFactor
                }
              }
            }
            const successConditionsResults = brigade.successConditionsResults
            if (successConditionsResults) {
              for (let i = 0; i < successConditionsResults.length; i++) {
                const result = successConditionsResults[i]
                const aggregatedType = getAggregatedConditionType(result.type)
                if (conditionsResultsInfo[aggregatedType] === undefined) {
                  conditionsResultsInfo[aggregatedType] = 0
                }
              }
            }

            if (unsuccessConditionsResults || successConditionsResults) {
              let maxWarnLevel = 0
              let blocksCount = 0
              let warnsCount = 0
              const warnLevels = Object.values(conditionsResultsInfo)
              for (let i = 0; i < warnLevels.length; i++) {
                const warnLevel = warnLevels[i]
                if (warnLevel > maxWarnLevel) {
                  maxWarnLevel = warnLevels[i]
                }
                if (warnLevel >= 5) {
                  blocksCount++
                } else if (warnLevel >= 1) {
                  warnsCount++
                }
              }
              conditionsResultsInfo.maxWarnLevel = maxWarnLevel
              conditionsResultsInfo.blocksCount = blocksCount
              conditionsResultsInfo.warnsCount = warnsCount
            }
            this.$set(brigade, 'conditionsResultsInfo', conditionsResultsInfo)

            brigade.score = Math.ceil(brigade.score) // учитывать дробные части ???
          })

          function compareBrigades (info1, info2, score1, score2) { // ASC
            // Направление работ приоритетнее
            if ((info1.workArea !== undefined && info1.workArea !== 0) || (info2.workArea !== undefined && info2.workArea !== 0)) {
              if (info1.workArea === undefined || info1.workArea === 0) { // undefined || 0
                return 1
              } else if (info2.workArea === undefined || info2.workArea === 0) {
                return -1
              }
            }
            let result = info1.maxWarnLevel - info2.maxWarnLevel
            if (result !== 0) {
              return -result
            }
            result = info1.blocksCount - info2.blocksCount
            if (result !== 0) {
              return -result
            }
            result = score1 - score2
            if (result !== 0) {
              return result
            }
            result = info1.warnsCount - info2.warnsCount
            if (result !== 0) {
              return -result
            }
            return 0
          }

          proposedBrigades.sort((br1, br2) => { // DESC
            if (br1.accessible && !br2.accessible) {
              return -1
            } else if (!br1.accessible && br2.accessible) {
              return 1
            }
            return -compareBrigades(br1.conditionsResultsInfo, br2.conditionsResultsInfo, br1.score, br2.score)
          })

          return Promise.resolve(proposedBrigades)
        },
        onFailure: (response) => {
          throw new Error(response.message)
        },
        msgTarget: this,
        throws: true
      })
    },
    getProposedBrigadesSimple: function (request) {
      return this.$refs.brigadeSelectorSimple.getBrigades(null, null, request) // promise
    },
    onProposedBrigadeSelectedSimple: function (proposedBrigade) {
      this.tempProposedBrigade = proposedBrigade
      this.saveSelectedProposedBrigade()
      this.proposedBrigadesSimpleOpened = false
    },
    onProposedBrigadeSelected: function (proposedBrigade) {
      if (this.reinforcement) {
        this.selectedReinforcementBrigades = proposedBrigade
      } else {
        this.tempProposedBrigade = proposedBrigade
      }
    },
    saveSelectedProposedBrigade: function () {
      if (this.reinforcement) {
        this.proposedExecutorObject = {
          type: 'reinforcementBrigades',
          names: [],
          executors: []
        }

        this.selectedReinforcementBrigades.forEach(br => {
          this.proposedExecutorObject.executors.push(br)
          this.proposedExecutorObject.names.push(br.brigadeName)
        })

        if (!this.proposedExecutorObject.executors.length) {
          this.proposedExecutorObject = null
        }
      } else {
        if (this.tempProposedBrigade) {
          this.proposedExecutorObject = {
            type: 'brigade',
            name: this.tempProposedBrigade.brigadeName,
            executor: this.tempProposedBrigade
          }

          if (this.tempProposedBrigade.isChecked) {
            const reinforcementBrigades = this.proposedBrigades.filter(br => br.brigadeId !== this.tempProposedBrigade.brigadeId && br.isChecked)
            this.request.proposedReinforcementExecutorObject = {
              type: 'reinforcementBrigades',
              names: reinforcementBrigades.map(br => br.brigadeName),
              executors: reinforcementBrigades
            }
          }
        } else {
          this.proposedExecutorObject = null
        }
      }

      this.tempProposedBrigade = null
      this.closeProposedBrigadesModal()
      this.confirm()
    },
    getClearedReinforcementExecutorObject: function () {
      let executors
      if (this.request.riAssignedBrigades.length) {
        executors = this.request.riAssignedBrigades.filter(br => (br.riStateId === 'RI3' || br.riStateId === 'RI4')).map(br => {
          return Object.assign({
            brigadeId: br.id,
            brigadeName: br.name
          }, br)
        })
      } else {
        executors = []
      }
      if (this.request.proposedReinforcementExecutorObject !== null && this.request.riAssignedBrigades.length === executors.length) {
        return null
      } else if (this.request.proposedReinforcementExecutorObject !== null || this.request.riAssignedBrigades.length !== executors.length) {
        return {
          type: 'reinforcementBrigades',
          names: executors.map(br => br.brigadeName),
          executors: executors
        }
      }
    },
    clearSelectedReinforcementBrigades: function () {
      this.proposedExecutorObject = this.getClearedReinforcementExecutorObject()
      if (this.proposedExecutorObject) {
        this.selectedReinforcementBrigades = this.proposedExecutorObject.executors.slice()
      } else {
        this.selectedReinforcementBrigades = []
      }
      this.tempProposedBrigade = null
      this.closeProposedBrigadesModal()
      this.confirm()
    },
    closeProposedBrigadesModal: function () {
      this.proposedBrigadesModalOpened = false
    },
    showProposedEmployees: function () {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        persistent: true,
        contentWidth: this.request._configuration.proposeExecutorsByWorkSchedule ? 800 : 1200,
        noWrap: true,
        contentComponent: RequestProposedEmployees,
        contentProps: {
          request: this.request,
          style: 'height: 100%; min-height: 400px;'
        },
        componentHandlers: {
          confirm: (proposedEmployee) => {
            if (proposedEmployee) {
              this.proposedExecutorObject = {
                type: 'employee',
                name: proposedEmployee.fio,
                executor: proposedEmployee
              }
            } else {
              this.proposedExecutorObject = null
            }

            dialog.hide()
            this.confirm()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },
    saveSelfSelection: function () {
      this.proposedExecutorObject = {
        type: 'self',
        name: this.user.name,
        login: this.user.login,
        executor: this.user.employee
      }
      this.confirm()
    }
  }
}

